<template>
  <div :style ="{'max-height': this.timeLineHeight + 'px'}"
       style = "overflow-y: scroll">
    <el-form :model="signInfo" :rules="rules" ref="signInfo" label-width="160px">
      <el-form-item label="商户名称">
        <el-input disabled>禾丰食品股份有限公司</el-input>
      </el-form-item>
      <el-form-item label="客户名称" prop="customerName">
        <el-input v-model="signInfo.customerName"></el-input>
      </el-form-item>
      <el-form-item label="身份证号" prop="idCardNo">
        <el-input v-model="signInfo.idCardNo"></el-input>
      </el-form-item>
      <el-form-item label="签约组织信息">

      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {signApply,customerSign} from "../../../api/system/bank_abc";
import {mapGetters} from "vuex";

export default {
  data(){
    return{
      signInfo: {
        username:'',
        companyId:'',
        companyName:'',
        idCardNo:'',
        customerId:'',
        customerName :''
      },
      rules:{
        customerName:[
          { required: true , message:'请输入客户姓名' , trigger: 'blur'}
        ],
        idCardNo:[
          { required: true , message:'请输入客户身份证号' , trigger: 'blur'}
        ]
      },
      timeLineHeight:''
    }
  },
  computed: {
    ...mapGetters(["currentUser"]),
    ...mapGetters(["companyOrgs"]),
    ...mapGetters(["index"]),
    ...mapGetters(["customerStorageOrg"]),
    ...mapGetters(["customerCompany"])
  },
  mounted(){
    this.timeLineHeight = document.documentElement.clientHeight -50;
    window.onresize = () => {
      this.timeLineHeight = document.documentElement.clientHeight;
    };
    if(this.index === null){
      this.$message({
        type:'error',
        message:'请在财务组织选择页面选取个人所属公司！'
      });
      return;
    }
  },
  methods:{
    submitForm(formName){
      let _this = this;
      this.$refs[formName].validate((valid) => {

      })
    }
  }
}
</script>

<style scoped>

</style>
